import React from "react"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../../localization/strings"
import EmployeeTimecard from "../EmployeeTimecard"
import UserStore from "../../../stores/UserStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import Paper from "material-ui/Paper"
import autobind from "class-autobind"
import { CircularProgress } from "material-ui"
import * as userActions from "../../../actions/UserActions"
import * as permissionHelper from "../../../helpers/permissionHelper"
import { ELoggedInUserType, IUserDocument, IDate } from "../../../models"
import * as userTimecardActions from "../../../actions/UserTimecardActions"
import AppStateStore from "../../../stores/AppStateStore"

interface IProps {
	open: boolean
	employeeId: string
	referenceDate: IDate
	readonly?: boolean
	handleClose(): void
	handleRecalcPage?(): void

	// from employee->timecard->virtual timecad popup
	virtualTimecard?: boolean

	// we should show only Job Data in timecard when open popup from Job->Timecard page
	filterByJobId?: string
	// if Job->Timecard, it's not full timecard object. so let's hide Info icon to show Notes, Audits and WorkHistory.
	hideInfoIcon?: boolean
}
interface IState {
	loggedInUserType: ELoggedInUserType
	user: IUserDocument
	acceptSuspensePunches: boolean
}

export default class TimecardPopup extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			loggedInUserType: permissionHelper.getLoggedInUserType(),
			user: props.virtualTimecard && UserStore.getCurrentUserDetail(),
			acceptSuspensePunches: false,
		}
		autobind(this)
	}

	componentDidMount() {
		if (!this.props.virtualTimecard) {
			userTimecardActions.handleChangeReferenceDate(this.props.referenceDate)
			UserStore.on("change", this.changeEvent)
			setTimeout(() => {
				userActions.loadUserDetails(this.props.employeeId)
			}, 0)
		}
	}

	componentWillUnmount() {
		if (!this.props.virtualTimecard) {
			UserStore.clearCurrentUserDetail()
			UserStore.removeListener("change", this.changeEvent)
		}
	}

	changeEvent() {
		this.setState({ user: UserStore.getCurrentUserDetail() })
	}

	handleAcceptSuspensePunches() {
		this.setState({ acceptSuspensePunches: true })
	}

	render() {
		const height = window.innerHeight * 0.8
		const actions = !this.props.readonly && this.props.virtualTimecard && !this.state.acceptSuspensePunches ?
			[
				<FlatButton data-intercom-target={"TimecardPopup-Btn-CloseTimecardPopup"} label={strings.Cancel} secondary onClick={this.props.handleClose} />,
				<FlatButton data-intercom-target={"TimecardPopup-Btn-AcceptSuspensePunches"} label={strings.Accept_Suspense_Punches} primary
					onClick={() => AppStateStore.setConfirmDialogContent({
						content: strings.Are_you_sure_you_want_to_accept_suspense_punches,
						confirm: this.handleAcceptSuspensePunches
					})}
				/>
			] :
			[<FlatButton data-intercom-target={"TimecardPopup-Btn-CloseTimecardPopup"} label={strings.Close} primary onClick={this.props.handleClose} />]
		return (
			<Dialog actions={actions} modal open={this.props.open} onRequestClose={this.props.handleClose} bodyStyle={{ padding: 0 }} contentStyle={{ width: "80%", maxWidth: "none" }}>
				<Paper
					zDepth={1}
					style={{ textAlign: "left", margin: 10, marginBottom: 5, height, overflowY: "auto", fontSize: 13 }}
				>
					{!this.state.user ?
						<div style={{ textAlign: "center", marginTop: "35%" }}>
							<CircularProgress />
						</div> :
						<EmployeeTimecard
							userId={this.props.employeeId}
							user={this.state.user}
							readonly={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.EditTimecards)}
							timecardApprovals
							loggedInUserType={this.state.loggedInUserType}
							handleRecalcPage={this.props.handleRecalcPage}
							byPopup
							virtualTimecard={this.props.virtualTimecard}
							acceptSuspensePunches={this.state.acceptSuspensePunches}
							filterByJobId={this.props.filterByJobId}
							hideInfoIcon={this.props.hideInfoIcon}
						/>
					}
				</Paper>
			</Dialog>
		)
	}
}